<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/link-client">Links clientes </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Novo Link</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <form @submit="save">
            <div class="row mt-4">
                <div class="col-xl-7 col-md-7 col-sm-12">
                    <div class="card shadow mb-4">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Dados do link</h6>
                        </div>
                        <!-- Card Header - Dropdown -->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Link*</label>
                                    <input type="text" class="form-control" v-model="link.url"
                                        placeholder="Ex: https://gruposoul.com.br">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" v-model="link.description"
                                        placeholder="Ex: Link vídeo tutorial">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Categoria*</label>
                                    <input type="text" @keydown="search()" class="form-control" v-model="link.category"
                                        placeholder="Ex: Tutoriais">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Data Expiração (Opcional)</label>
                                    <input type="date" class="form-control" v-model="link.expiration">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Link Público*</label>
                                    <div class="input-group mb-3">
                                        <multiselect v-model="link_public_multiselect" :options="link_public_options"
                                            placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                            :custom-label="linkPublicWithLang" :deselect-label="'Clique para remover'"
                                            @select="handleSelectLinkPublic">
                                            <template #noResult>
                                                Opção não encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <ul class="autocomplete-list-link">
                                    <li class="list-item-link pointer" v-for="(result, index) in results" :key="index"
                                        @click="setCategorie(result)">
                                        {{ result }}
                                    </li>
                                </ul>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Comentários (Opcional)</label>
                                    <editorTextSimple @update-text="updateObservation" :modelValue="link.observation"
                                        placeholderSend="Link referente à...." ref="myChild">
                                    </editorTextSimple>
                                </div>
                            </div>
                            <div class="row mt-3 float-right">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>

                                    <router-link to="/link" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-md-5 col-sm-12">
                    <div class="card shadow mb-4">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Clientes vinculados ao link</h6>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Selecione um ou mais clientes*</label>
                                    <multiselect v-model="client_multiselect" :options="clients_options"
                                        :custom-label="clientWithLang" placeholder="Selecione uma opção"
                                        @select="handleSelectClient" :disabled="this.link.public == '1'">

                                        <template #noResult>
                                            Nenhum cliente encontrado.
                                        </template>
                                    </multiselect>
                                    <button type="button" class="btn btn-success mt-2" @click="addAllClientList" :disabled="this.link.public == '1'"><i
                                            class="fa fa-check"></i>Adicionar
                                        todos os clientes</button>
                                    <button type="button" class="btn btn-danger mt-2 ml-2"
                                        @click="removeAllClientList" :disabled="this.link.public == '1'"><i class="fa fa-ban"></i>
                                        Remover todos os
                                        clientes</button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Lista de clientes adicionados</label>
                                    <div class="table-responsive limitHeightListClient">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead v-if="client_selected.length > 0">
                                                <tr>
                                                    <th>Documento</th>
                                                    <th>Nome</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(client, index) in client_selected" :key="index">
                                                    <td>{{ client.document }} </td>
                                                    <td>{{ client.name }} </td>
                                                    <td><button class="btn btn-danger"
                                                            @click="removeClientList(client.key)"><i
                                                                class="fa fa-trash"></i></button></td>
                                                </tr>
                                                <tr v-if="client_selected.length == 0">
                                                    <td class="text-center">Nenhum cliente selecionado</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>


</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect'
import editorTextSimple from '../util/editor-text-simple.vue';


import 'vue-loading-overlay/dist/css/index.css';
export default {

    components: { Loading, Multiselect, editorTextSimple },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            results: [],
            link: {
                description: '',
                category: '',
                url: '',
                public: '1',
                expiration: '',
                observation: ''
            },
            link_public_multiselect: { type: '1', value: 'Sim' },
            link_public_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            clients: [],
            clients_options: [],
            client_multiselect: '',
            client_selected: [],
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.link.description != '' && this.link.category != '' && this.link.url != '' && ( this.client_selected.length > 0 || this.link.public == '1');
        }
    },
    mounted() {
        this.isLoading = false;
        const response = this.getclients();
        response.then(() => {
            this.clients_options = this.clients.map(client => ({
                key: client.id,
                value: client.mat?'Mat: '+client.mat+' Documento: ' + client.document_formatted + '| Nome: ' + client.name:'Documento: ' + client.document_formatted + '| Nome: ' + client.name,
                name: client.name,
                document: client.document_formatted
            }));
        });

    },
    methods: {
        onCancel() { },
        linkPublicWithLang({ value }) {
            return value;
        },

        handleSelectLinkPublic(option) {
            this.link.public = option.type;
            if(this.link.public == '1'){
                this.client_selected = [];
            }
        },


        inListClientSelected(key) {
            let inserted = false;
            this.client_selected.forEach(client => {
                if (client.key == key) {
                    inserted = true;
                }
            });
            return inserted;
        },

        handleSelectClient(option) {
            if (!this.inListClientSelected(option.key)) {
                this.client_selected.push({ 'key': option.key, 'document': option.document, 'name': option.name });
            }
            this.client_multiselect = '';


        },

        updateObservation(observation) {
            this.link.observation = observation;
        },

        clientWithLang({ value }) {
            return value;
        },

        addAllClientList() {
            this.client_selected = [];
            this.clients.map(client => (this.client_selected.push({ 'key': client.id, 'document': client.document_formatted, 'name': client.name })));
        },

        removeAllClientList() {
            this.client_selected = [];
        },
        removeClientList(element) {
            const index = this.client_selected.findIndex(item => item.key === element);
            if (index > -1) {
                this.client_selected.splice(index, 1);
            }

        },
        async getclients() {
            this.loading = true;
            const response = await api.get('/client', { params: { 'all_clientes': true, 'status': 'Ativo' } })
                .then((response) => {
                    this.clients = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            let clients_selected = JSON.stringify(this.client_selected);
            const formData = new FormData();
            console.log(this.link);
            formData.append('description', this.link.description);
            formData.append('category', this.link.category);
            formData.append('public', this.link.public);
            formData.append('url', this.link.url);
            if (this.link.observation != '') {
                formData.append('observation', this.link.observation);
            }
            if (this.link.expiration != '') {
                formData.append('expiration', this.link.expiration);
            }

            formData.append('clients', clients_selected);
            api.post('/link-client', formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Link cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.link = {};
                    this.link.category = '';
                    this.client_selected = [];
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },


        search() {
            if (this.link.category.length >= 2) {
                api.get('/link-client', {
                    params: {
                        'only_categories': true,
                        'search': this.link.category
                    }
                })
                    .then((response) => {
                        if (response.data.categories.length > 0) {
                            this.results = response.data.categories;
                        } else {
                            this.results = {};
                        }

                    }).catch(error => {
                        handleRequestErrors(error)

                    })
            }
        },
        setCategorie(name) {
            this.link.category = name;
            this.results = {};
        }

    }
}
</script>

<style>
.limitHeightListClient {
    height: 320px;
    overflow-y: auto;
    scrollbar-color: darkblue lightgrey;
    border-bottom: 1px solid #e0e0e0;
}

.limitHeightListClient table {
    width: 100%;
    border-collapse: collapse;
}

.autocomplete-list-link {
    position: absolute;
    list-style-type: none;
    background: #fff;
    width: 100%;
    margin-top: 80px;
    box-shadow: 0 0 10px #ddd;
    background: #e9e9e9;
    transition: all 300ms ease-out;
    transform: scale(1) translateY(0);
    transform-origin: center center;
    z-index: 99999;
    max-height: 300px;
    overflow-y: auto;
}

.list-item-link {
    padding: 10px;
    padding-left: 0px;
    border-top: 1px solid #0000001f;
    background: #e9e9e9;
}

.list-item-link:hover {
    background: #d8d8d8;
}
</style>